import axios from "axios";
import { alert_messages, error_messages } from "../consts/messages";
import { append_to_dom, catch_error, get_user_info } from "./functions";

var cookbook_name = "";
var is_cookbook_public = false;
var private_cookbook = "كتاب طبخ خاص";
var public_cookbook = "كتاب طبخ عام";
var privacy_message = private_cookbook;
var cookbook_image =
  "/wp-content/themes/atyabtabkha/src/assets/images/svg/ico-book.svg";
var user_cookbooks = [];

var authors_ids = [];

jQuery(document).ready(function ($) {
  if (
    window.location.pathname.includes("/recipe/") &&
    !window.location.pathname.endsWith("recipe/")
  ) {
    if ($("#authors_ids").data("authors-ids")) {
      authors_ids = $("#authors_ids").data("authors-ids") + "";
      authors_ids = authors_ids.split("__");
    }
  }

  var post = $("#post-id").attr("data-post-id");

  $(document).on("click", "#add_to_new_cookbook_box", function () {
    $(this).addClass("is-form-open");
    $("#add_to_cookbook_submit_container").css("display", "flex");
  });

  //~ Clear Fields after clicking close button
  $(document).on("click", "#add_to_new_cookbook_cancel", function () {
    clear_fields();
  });

  //~ Validation cookbook name
  $(document).on("change input focus", "#box-field", function (e) {
    cookbook_name = e.target.value;
    if (e.target.value === "") {
      $("#add_to_new_cookbook_submit").prop("disabled", true);
    } else {
      $("#add_to_new_cookbook_submit").prop("disabled", false);
    }
  });

  $(document).on("change", "#list-radios input", function (e) {
    if (e.target.attributes["data-is-public"].value == "true") {
      privacy_message = public_cookbook;
    } else {
      privacy_message = private_cookbook;
    }
  });

  //! If the user has no cookbooks
  if (window.location.pathname.includes("/recipe/")) {
    list_cookbooks_main();
  }

  //~ Function to be toggled
  function clear_fields() {
    $("#add_to_new_cookbook_box").removeClass("is-form-open");
    $("#add_to_cookbook_submit_container").css("display", "none");

    cookbook_name = "";
    is_cookbook_public = false;
    privacy_message = "";

    $("#box-field").val("");
    $("#list-radios #public-cookbook")
      .attr("checked", false)
      .prop("checked", false);
    $("#list-radios #private-cookbook")
      .attr("checked", true)
      .prop("checked", true);
  }

  $(document).on("submit", "#add_to_new_cookbook_form", function (e) {
    e.preventDefault();
    create_cookbook();
  });

  // ~ Toggle add_to_cookbook()
  $(document).on("click", ".article--add", function () {
    let cookbook = $(this)[0]
      .attributes["data-cookbook-name"].value.split("_")
      .join(" ");
    let i = $(this)[0].attributes["data-count"].value;
    let count = parseInt($(`#cookbook-count-${i}`).text());

    add_to_cookbook(cookbook, count, i);
    let name = $(this)[0].attributes["data-cookbook-name"].value;
    if ($(`#${name}_image`).css("backgroundImage").includes(cookbook_image)) {
      $(`#${name}_image`)
        .addClass("has--image--cookbook")
        .css("backgroundImage", $(".galery__image").css("backgroundImage"))
        .css("background-size", "cover");
    }
  });

  // ~ Add recipe to existing cookbook
  function add_to_cookbook(cookbookName, count, i) {
    let new_count = count;
    const url = `${savedSettings.api_url}/cookbook`;
    let body = {
      action: "recipes",
      recipeToAdd: post,
      categoryName: cookbookName,
      authorUIDs: authors_ids,
    };
    axios
      .post(url, body, {
        headers: {
          "x-api-key": savedSettings.x_api_key,
          contentType: "application/json; charset=utf-8",
          Authorization: ` Bearer ${
            JSON.parse(localStorage.getItem("login_result"))?.access_token
          }`,
        },
      })
      .then(() => {
        $("#add_to_new_cookbook_submit").removeClass("button--loading");

        $("#cookbook-button-image").css(
          "filter",
          "invert(63%) sepia(76%) saturate(7491%) hue-rotate(324deg) brightness(95%) contrast(98%)"
        );
        $("#cookbook-button-text").css("color", "#F13467");

        //~ Incement the recipe count number
        new_count++;
        $(`#cookbook-count-${i}`).text(new_count);

        //~ Fetch user info to have up-to-date cookbooks

        get_user_info(false, false, true);

        //~ Close modal an clear input tags
        $("#popup-book").remove();

        //~ Change notification toast text
        $("#favorite-tooltip-text p").text(alert_messages.added_to_cookbook);

        //~ Add notification toast
        $("#cookbook-tooltip").addClass("is-active");
        setTimeout(() => {
          $("#cookbook-tooltip").removeClass("is-active");
        }, 3000);

        $(`.article__remove[data-count='${i}']`).css("display", "block");
        $(`.article--add[data-count='${i}']`).css("display", "none");
      })
      .catch((err) => {
        catch_error(err);
        $("#add_to_new_cookbook_submit").removeClass("button--loading");
      });
  }

  // ~ Toggle remove_from_cookbook()
  $(document).on("click", ".article__remove", function () {
    let cookbook = $(this)[0]
      .attributes["data-cookbook-name"].value.split("_")
      .join(" ");
    let i = $(this)[0].attributes["data-count"].value;
    let count = parseInt($(`#cookbook-count-${i}`).text());
    remove_from_cookbook(cookbook, i, count);
    let id = $(this)[0].attributes["data-cookbook-name"].value;
    let recipe_image = "";
    let old_cookbook_image = "";
    if ($(".galery__image").css("backgroundImage")) {
      recipe_image = $(".galery__image")
        .css("backgroundImage")
        .split("/")[6]
        .split("?")[0]
        .split(".")[0];
      old_cookbook_image = $(`#${id}_image`)
        .css("backgroundImage")
        .split("/")[6]
        .split("?")[0]
        .split(".")[0];
    }
    if (old_cookbook_image == recipe_image) {
      $(`#${id}_image`).css("background-image", "url(" + cookbook_image + ")");
      $(`#${id}_image`).css("background-size", "auto");
      $(`#${id}_image`).css("border", "0.1rem solid #E2E2E2");
    }
  });

  // ~ Remove recipe from a cookbook
  function remove_from_cookbook(cookbook_name, i, new_count) {
    const url = `${savedSettings.api_url}/cookbook`;
    let body = {
      action: "recipes",
      categoryName: cookbook_name,
      recipeToRemove: post,
      authorUIDs: authors_ids,
    };

    axios
      .post(url, body, {
        headers: {
          "x-api-key": savedSettings.x_api_key,
          contentType: "application/json; charset=utf-8",
          Authorization: ` Bearer ${
            JSON.parse(localStorage.getItem("login_result"))?.access_token
          }`,
        },
      })
      .then(() => {
        $("#add_to_new_cookbook_submit").removeClass("button--loading");

        $("#cookbook-button-image").css("filter", "none");
        $("#cookbook-button-text").css("color", "#2e2e2e");

        //~ Decrement the recipe count number
        new_count--;
        $(`#cookbook-count-${i}`).text(new_count);

        //~ Fetch user info to have up-to-date cookbooks

        get_user_info(false, false, true);

        //~ Close modal an clear input tags
        $("#popup-book").remove();

        //~ Change notification toast text
        $("#favorite-tooltip-text p").text(
          alert_messages.removed_from_cookbook
        );

        //~ Add notification toast
        $("#cookbook-tooltip").addClass("is-active");
        setTimeout(() => {
          $("#cookbook-tooltip").removeClass("is-active");
        }, 3000);

        $(`.article__remove[data-count='${i}']`).css("display", "none");
        $(`.article--add[data-count='${i}']`).css("display", "block");
      })
      .catch((err) => {
        $("#add_to_new_cookbook_submit").removeClass("button--loading");

        catch_error(err);
      });
  }

  //~ Create a new Cookbook
  function create_cookbook() {
    $("#add_to_new_cookbook_submit").addClass("button--loading");
    const url = `${savedSettings.api_url}/cookbook`;
    let body = {
      action: "create",
      categoryName: cookbook_name,
      isPublic: is_cookbook_public,
      recipeToAdd: post,
      authorUIDs: authors_ids,
    };

    axios
      .post(url, body, {
        headers: {
          "x-api-key": savedSettings.x_api_key,
          contentType: "application/json; charset=utf-8",
          Authorization: ` Bearer ${
            JSON.parse(localStorage.getItem("login_result"))?.access_token
          }`,
        },
      })
      .then(() => {
        $("#add_to_new_cookbook_submit").removeClass("button--loading");
        $("#cookbook_error").text("");
        $("#cookbook-button-image").css(
          "filter",
          "invert(63%) sepia(76%) saturate(7491%) hue-rotate(324deg) brightness(95%) contrast(98%)"
        );
        $("#cookbook-button-text").css("color", "#F13467");

        //~ Close modal and clear input tags
        $("#popup-book").remove();

        //~ Change notification toast text
        $("#favorite-tooltip-text p").text(alert_messages.added_to_cookbook);

        //~ Add notification toast
        $("#cookbook-tooltip").addClass("is-active");
        setTimeout(() => {
          $("#cookbook-tooltip").removeClass("is-active");
        }, 3000);
        privacy_message = private_cookbook;
      })
      .then(() => {
        // ~ Fetch user info to have up-to-date cookbooks
        get_user_info(false, false, true);
      })
      .catch((err) => {
        catch_error(err);
        if (err) {
          if (err.response) {
            if (err.response.status) {
              if (err.response.status == 403) {
                $("#cookbook_error").text(error_messages.cookbook_exists);
              }
            }
          }
        }
        $("#add_to_new_cookbook_submit").removeClass("button--loading");
      });
  }

  $("#onCookbookClick").on("click", function () {
    if (!JSON.parse(localStorage.getItem("login_result"))?.is_logged_in) {
      localStorage.setItem("render_cookbooks", true);
      append_to_dom("popup-login-open", "popup-login", null);
    } else {
      append_to_dom("popup-cookbook-open", "popup-book", list_cookbooks_main);
    }
  });
});

export function list_cookbooks_main() {
  if (localStorage.getItem("user_info")) {
    if (JSON.parse(localStorage.getItem("user_info"))?.cookbooks) {
      user_cookbooks = JSON.parse(localStorage.getItem("user_info"))?.cookbooks;
      if (user_cookbooks.length == 0) {
        $("#add_to_new_cookbook_box").addClass("is-form-open");
        $("#add_to_cookbook_submit_container").css("display", "flex");
      } else {
        list_cookbooks(user_cookbooks);
      }
    }
  }
}

function list_cookbooks(user__cookbooks) {
  let post__id = $("#post-id").data("post-id");

  let data = `&action=load_cookbook_actions&post__id=${post__id}&user__cookbooks=${JSON.stringify(
    user__cookbooks
  )}`;

  $.ajax({
    type: "POST",
    dataType: "html",

    url: load_cookbook_actions.ajaxurl,
    data: data,
    beforeSend: function () {
      $("#popup-book .popup__body").remove();
      $("#popup-book .popup__inner").append('<div class="popup__body"></div>');
    },

    success: function (res) {
      $("#popup-book .popup__body").append(res);
    },
    error: function (jqXHR, textStatus, errorThrown) {
      console.log(jqXHR);
      console.log(textStatus);
      console.log(errorThrown);
    },
  });
}
